document.addEventListener('DOMContentLoaded', function () {
    const links = document.querySelectorAll('.woocommerce-product-attributes-item--attribute_pa_size a')

    links.forEach(link => {
        const textNode = document.createTextNode(link.textContent)
        link.parentNode.replaceChild(textNode, link)
    })

    const elements = document.querySelectorAll('.woocommerce-Tabs-panel [target="_blank"]');

    elements.forEach(element => {
        element.removeAttribute('target');
    });
})
